enum OpPermissions {
  SHOW_NETTO_PRICE = 'showNettoPrice',
  SHOW_BRUTTO_PRICE = 'showBruttoPrice',
  PROCESSES_ENABLED = 'searchProcessesEnabled',
}

export default OpPermissions;
